import Link from "next/link";
import useFetchData from "../../hooks/useFetchData";
import urlToHttp from "../../utils/urlToHttp";
import { DEFAULT_SUPPORTED_CHAINS } from "@usedapp/core";
import { KARATDAO_DEFAULT_SUPPORTED_CHAINS } from "@/chain-info/KaratDaoSupportedChain";
import { useState, useEffect } from "react";
import classnames from "classnames";
import ImageProcessor from "../ImageProcessor";
import { getChainIcon } from "@/utils/format";

export const CarouselMobileItem = ({ campaign, feature }) => {
  const [load, setLoad] = useState(false);
  const {
    // loading: baseInfoURILoading,
    // error: baseInfoURIError,
    data: baseInfoURIData,
  } = useFetchData(campaign?.baseInfo);
  useEffect(() => {
    if (
      baseInfoURIData !== undefined &&
      baseInfoURIData.image_preview === undefined
    ) {
      baseInfoURIData.image_preview =
        urlToHttp(baseInfoURIData?.image_hash)[0] ?? //FIXME
        urlToHttp(baseInfoURIData?.image)[0];
    }
  }, [baseInfoURIData]);
  // console.log(campaign);
  // console.log(baseInfoURIData);
  const expectedChain = KARATDAO_DEFAULT_SUPPORTED_CHAINS.find(
    (network) => network.chainId === campaign?.chainId
  );
  const chainName = expectedChain?.chainName;
  const chainNameEth = chainName === "Mainnet" ? "Ethereum" : chainName;
  // const icon = useMemo(() => {
  //   return chainName
  //     ? `https://defillama.com/chain-icons/${chainLogo}.jpg`
  //     : '/unknown-logo.png';
  // }, [chainName, chainLogo]);
  // eslint-disable-next-line
  const chainIcon = getChainIcon(chainNameEth);
  return (
    <Link
      href={`/airdrops/${chainName}/${campaign?.type?.toLowerCase()}/${
        campaign?.airdropAddr
      }`}
    >
      <div
        className={classnames(
          "flex w-full flex-col",
          feature
            ? "h-full justify-between rounded-sm bg-bgv"
            : "h-full justify-between rounded-sm bg-white"
        )}
      >
        <div className="flex h-64 w-full">
          <ImageProcessor
            src={baseInfoURIData?.image}
            size="s300"
            className="w-full rounded-sm object-cover object-center"
          />
          {/* <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div> */}
        </div>
        <div className="flex h-28 w-full flex-col justify-between">
          <div className="mx-3 mt-3 flex">
            <p
              className={
                feature
                  ? "overflow-hidden text-ellipsis text-lg font-bold text-primary"
                  : "overflow-hidden text-ellipsis text-lg font-bold text-black"
              }
            >
              {campaign?.name.length <= 60
                ? campaign?.name
                : campaign?.name.substring(0, 60) + "..."}
            </p>
          </div>
          <div
            className={
              feature
                ? "mx-3 flex flex-row justify-between pb-5 text-xs text-gray"
                : "mx-3 flex flex-row justify-between pb-5 text-xs text-black"
            }
          >
            <div>Max Supply</div>
            <div>
              {campaign?.type === "TOKEN"
                ? campaign?.reach
                : campaign?.maxSupply}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};
